import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { BUSINESS } from "../data/business";

export default function PrivacyPage() {
  return (
    <>
      <Seo
        title="Polityka prywatności | BEAUTIX Katowice"
        description="Polityka prywatności Studio Kosmetyki Nowoczesnej BEAUTIX w Katowicach — zasady przetwarzania danych osobowych i plików cookies."
        path="/polityka-prywatnosci"
      />

      <section className="max-w-4xl mx-auto px-6 md:px-10 pt-8 pb-4">
        <Breadcrumbs items={[{ label: "Polityka prywatności" }]} />
      </section>

      <article className="max-w-3xl mx-auto px-6 md:px-10 py-12 md:py-20">
        <p className="eyebrow mb-4">Polityka prywatności</p>
        <h1 className="font-serif-display text-4xl md:text-6xl leading-[1.05] mb-10">
          Twoja prywatność ma dla nas znaczenie.
        </h1>

        <div className="space-y-8 text-[var(--beautix-muted)] leading-relaxed font-light text-base">
          <section>
            <h2 className="font-serif-display text-2xl md:text-3xl text-[var(--beautix-ink)] mb-3">
              1. Administrator danych
            </h2>
            <p>
              Administratorem Twoich danych osobowych jest {BUSINESS.name},
              {" "}{BUSINESS.address.street}, {BUSINESS.address.postalCode}{" "}
              {BUSINESS.address.city}. Kontakt: {BUSINESS.email},
              tel. {BUSINESS.phones[1].number}.
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl md:text-3xl text-[var(--beautix-ink)] mb-3">
              2. Cel przetwarzania
            </h2>
            <p>
              Dane przetwarzamy w celu realizacji usług kosmetycznych,
              podologicznych i pielęgnacyjnych, kontaktu z klientem, obsługi
              rezerwacji telefonicznych oraz obowiązków księgowych zgodnie
              z obowiązującym prawem.
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl md:text-3xl text-[var(--beautix-ink)] mb-3">
              3. Podstawa prawna
            </h2>
            <p>
              Przetwarzanie danych odbywa się na podstawie art. 6 ust. 1 lit.
              a, b, c i f RODO (zgoda, wykonanie umowy, obowiązki prawne oraz
              uzasadniony interes administratora).
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl md:text-3xl text-[var(--beautix-ink)] mb-3">
              4. Pliki cookies
            </h2>
            <p>
              Strona wykorzystuje pliki cookies do celów statystycznych oraz
              poprawy komfortu użytkowania. Możesz zarządzać zgodą przez baner
              cookies lub ustawienia swojej przeglądarki.
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl md:text-3xl text-[var(--beautix-ink)] mb-3">
              5. Twoje prawa
            </h2>
            <p>
              Masz prawo dostępu do swoich danych, ich sprostowania, usunięcia,
              ograniczenia przetwarzania, przenoszenia oraz wniesienia
              sprzeciwu. W tym celu skontaktuj się z nami na adres {BUSINESS.email}.
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl md:text-3xl text-[var(--beautix-ink)] mb-3">
              6. Okres przechowywania
            </h2>
            <p>
              Dane przechowujemy tylko przez okres niezbędny do realizacji
              celu przetwarzania oraz zgodnie z obowiązującymi przepisami
              (m.in. rachunkowymi).
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl md:text-3xl text-[var(--beautix-ink)] mb-3">
              7. Kontakt
            </h2>
            <p>
              W sprawach związanych z przetwarzaniem danych osobowych napisz do
              nas na {BUSINESS.email} lub zadzwoń pod {BUSINESS.phones[1].number}.
            </p>
          </section>

          <p className="text-xs text-[var(--beautix-muted)] pt-6 border-t border-[var(--beautix-line)]">
            Ostatnia aktualizacja: grudzień 2025
          </p>
        </div>
      </article>
    </>
  );
}
